let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jo9Ab")).then(() => parcelRequire('hc56P'));